import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "context/AuthContext";
import { useFormFields } from "libs/fields";
import { onError } from "libs/error";
import { Auth } from "@aws-amplify/auth";
import { SubmitButton, EmailInput } from "components/FormElements";
import Header from "components/Header";
import SubHeader from "components/SubHeader";
import Footer from "components/Footer";

export default function ChangeEmail() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { user } = useUser();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<JSX.Element>(<span></span>);

  const [fields, handleFieldChange] = useFormFields({
    email: ""
  });

  function validateForm() {
    return fields.email.length > 0;
  }

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();

    setIsLoading(true);

    try {
      await Auth.updateUserAttributes(user, {
        email: fields.email
      });
      navigate("/account/verify", { state: { email: fields.email } });
    } catch (error: unknown) {
      const e = error as Error;
      const errorHandler = onError(e);
      setErrorMessage(errorHandler);
      setIsLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <SubHeader
        heading={t("local.account.changeemail.title.main").toString()}
        subheading={t("local.account.subtitle.subheader").toString()}
        path="/account"
      />
      <main className="flex-grow bg-ct-lightgrey px-4 md:px-0">
        <h2 className="text-3xl text-black text-center pt-20 mb-2.5">{t("local.account.changeemail.title.main")}</h2>
        <p className="text-base text-black text-center max-w-2xl mx-auto mb-6">
          {t("local.account.changeemail.subtitle.sectioninfo")}{" "}
          {user.preferredMFA === "SOFTWARE_TOKEN_MFA" && t("local.account.changeemail.subtitle.mfainfo")}
        </p>
        <form className="container mx-auto max-w-md flex flex-col justify-center space-y-4 pb-20" onSubmit={handleSubmit}>
          <div>
            <h3 className="text-xl">{t("local.account.changeemail.label.currentemail")}</h3>
            <code className="text-sm">{user.attributes.email}</code>
          </div>
          <h3 className="text-xl">{t("local.account.changeemail.label.newemail")}</h3>
          <EmailInput handleChange={handleFieldChange} value={fields.email} label={t("global.label.email")} />
          <SubmitButton disabled={!validateForm() || isLoading} loading={isLoading} label={t("global.button.confirmchange")} />
          <p className="">
            <Link to="/account" className="transition text-ct-orange hover:text-black">
              {t("global.link.returntoaccount")}
            </Link>
          </p>
          {errorMessage}
        </form>
      </main>
      <Footer />
    </div>
  );
}
